export default __webpack_public_path__ + "static/SiemensSans-Roman-370e90f96153ab16afd83376eaf47e90.ttf";